export const universities = {
  "agnes_scott_college": "Agnes Scott College",
  "alvernia_university": "Alvernia University",
  "american_university": "American University",
  "amherst_college": "Amherst College",
  "babson_college": "Babson College",
  "bard_college": "Bard College",
  "barnard_college": "Barnard College",
  "baylor_university": "Baylor University",
  "bennington_college": "Bennington College",
  "bentley_university": "Bentley University",
  "berry_college": "Berry College",
  "bethany_college": "Bethany College",
  "bishops_university": "Bishop’s University",
  "boston_college": "Boston College",
  "boston_university": "Boston University (BU)",
  "bowdoin_college": "Bowdoin College",
  "brandeis_university": "Brandeis University",
  "brown_university": "Brown University",
  "bryn_mawr_college": "Bryn Mawr College",
  "bucknell_university": "Bucknell University",
  "butler_university": "Butler University",
  "california_institute_of_technology": "California Institute of Technology (Caltech)",
  "california_lutheran_university": "California Lutheran University",
  "capitol_technology_university": "Capitol Technology University",
  "carleton_college": "Carleton College",
  "carnegie_mellon_university": "Carnegie Mellon University",
  "case_western_reserve_university": "Case Western Reserve University",
  "catawba_college": "Catawba College",
  "centre_college": "Centre College",
  "chapman_university": "Chapman University",
  "claremont_mckenna_college": "Claremont McKenna College",
  "clark_university": "Clark University",
  "college_of_mount_saint_vincent": "College of Mount Saint Vincent",
  "college_of_william_and_mary": "College of William and Mary",
  "college_of_wooster": "College of Wooster",
  "colorado_school_of_mines": "Colorado School of Mines",
  "columbia_university": "Columbia University",
  "cornell_university": "Cornell University",
  "culver_stockton_college": "Culver-Stockton College",
  "dyouville_university": "D'Youville University",
  "dartmouth_college": "Dartmouth College",
  "davidson_college": "Davidson College",
  "drexel_university": "Drexel University",
  "duke_university": "Duke University",
  "earlham_college": "Earlham College",
  "elon_university": "Elon University",
  "emerson_college": "Emerson College",
  "emory_university": "Emory University",
  "flagler_college": "Flagler College",
  "fordham_university": "Fordham University",
  "george_mason_university": "George Mason University",
  "george_washington_university": "George Washington University",
  "georgetown_university": "Georgetown University",
  "georgia_state_university": "Georgia State University",
  "georgia_tech": "Georgia Institute of Technology (Georgia Tech)",
  "harvard_university": "Harvard University",
  "harvey_mudd_college": "Harvey Mudd College",
  "haverford_college": "Haverford College",
  "hillsdale_college": "Hillsdale College",
  "hofstra_university": "Hofstra University",
  "illinois_institute_of_technology": "Illinois Institute of Technology",
  "illinois_wesleyan_university": "Illinois Wesleyan University",
  "indiana_university_bloomington": "Indiana University Bloomington",
  "ithaca_college": "Ithaca College",
  "johns_hopkins_university": "Johns Hopkins University",
  "kalamazoo_college": "Kalamazoo College",
  "lafayette_college": "Lafayette College",
  "lehigh_university": "Lehigh University",
  "lewis_and_clark_college": "Lewis and Clark College",
  "linfield_university": "Linfield University",
  "loyola_marymount_university": "Loyola Marymount University (LMU)",
  "lynn_university": "Lynn University",
  "macalester_college": "Macalester College",
  "malone_university": "Malone University",
  "manchester_university": "Manchester University",
  "marist_college": "Marist College",
  "mary_baldwin_university": "Mary Baldwin University",
  "massachusetts_institute_of_technology": "Massachusetts Institute of Technology (MIT)",
  "meredith_college": "Meredith College",
  "monmouth_college": "Monmouth College",
  "moravian_university": "Moravian University",
  "morehouse_college": "Morehouse College",
  "mount_holyoke_college": "Mount Holyoke College",
  "new_york_university": "New York University (NYU)",
  "north_park_university": "North Park University",
  "northeastern_university": "Northeastern University",
  "northwestern_university": "Northwestern University",
  "occidental_college": "Occidental College",
  "ohio_state_university": "Ohio State University",
  "oklahoma_city_university": "Oklahoma City University",
  "olin_college_of_engineering": "Olin College of Engineering",
  "pepperdine_university": "Pepperdine University",
  "pitzer_college": "Pitzer College",
  "pomona_college": "Pomona College",
  "princeton_university": "Princeton University",
  "providence_college": "Providence College",
  "purdue_university": "Purdue University",
  "rensselaer_polytechnic_institute": "Rensselaer Polytechnic Institute",
  "rice_university": "Rice University",
  "rutgers_university_new_brunswick": "Rutgers University - New Brunswick",
  "saint_elizabeth_university": "Saint Elizabeth University",
  "santa_clara_university": "Santa Clara University",
  "sarah_lawrence_college": "Sarah Lawrence College",
  "scripps_college": "Scripps College",
  "seattle_pacific_university": "Seattle Pacific University",
  "smith_college": "Smith College",
  "soka_university_of_america": "Soka University of America",
  "southern_methodist_university": "Southern Methodist University",
  "st_johns_college": "St. John’s College",
  "stanford_university": "Stanford University",
  "stonehill_college": "Stonehill College",
  "swarthmore_college": "Swarthmore College",
  "syracuse_university": "Syracuse University",
  "texas_a&m_university": "Texas A&M University",
  "texas_christian_university": "Texas Christian University",
  "the_college_of_idaho": "The College of Idaho",
  "the_george_washington_university": "The George Washington University",
  "the_new_school": "The New School",
  "trinity_college": "Trinity College",
  "tufts_university": "Tufts University",
  "tulane_university": "Tulane University",
  "university_of_california_berkeley": "University of California - Berkeley",
  "university_of_california_davis": "University of California - Davis",
  "university_of_california_irvine": "University of California - Irvine",
  "university_of_california_los_angeles": "University of California - Los Angeles",
  "university_of_california_merced": "University of California - Merced",
  "university_of_california_riverside": "University of California - Riverside",
  "university_of_california_san_francisco": "University of California - San Francisco",
  "university_of_california_san_diego": "University of California - San Diego",
  "university_of_california_santa_barbara": "University of California - Santa Barbara",
  "university_of_california_santa_cruz": "University of California - Santa Cruz",
  "university_of_central_florida": "University of Central Florida (UCF)",
  "university_of_chicago": "University of Chicago",
  "university_of_cincinnati": "University of Cincinnati",
  "university_of_colorado_boulder": "University of Colorado Boulder",
  "university_of_florida": "University of Florida",
  "university_of_georgia": "University of Georgia (UGA)",
  "university_of_illinois_urbana_champaign": "University of Illinois Urbana-Champaign",
  "university_of_maryland": "University of Maryland",
  "university_of_massachusetts_amherst": "University of Massachusetts Amherst",
  "university_of_miami": "University of Miami",
  "university_of_michigan": "University of Michigan",
  "university_of_minnesota_twin_cities": "University of Minnesota - Twin Cities",
  "university_of_north_carolina_at_chapel_hill": "University of North Carolina at Chapel Hill (UNC)",
  "university_of_north_carolina_at_charlotte": "University of North Carolina at Charlotte",
  "university_of_north_carolina_at_greensboro": "University of North Carolina at Greensboro",
  "university_of_notre_dame": "University of Notre Dame",
  "university_of_oklahoma": "University of Oklahoma",
  "university_of_oregon": "University of Oregon",
  "university_of_pennsylvania": "University of Pennsylvania",
  "university_of_pittsburgh": "University of Pittsburgh",
  "university_of_richmond": "University of Richmond",
  "university_of_rochester": "University of Rochester",
  "university_of_san_diego": "University of San Diego",
  "university_of_san_francisco": "University of San Francisco",
  "university_of_southern_california": "University of Southern California (USC)",
  "university_of_texas_austin": "University of Texas at Austin",
  "university_of_tulsa": "University of Tulsa",
  "university_of_vermont": "University of Vermont",
  "university_of_virginia": "University of Virginia",
  "university_of_washington": "University of Washington",
  "university_of_wisconsin_madison": "University of Wisconsin-Madison",
  "vanderbilt_university": "Vanderbilt University",
  "vassar_college": "Vassar College",
  "villanova_university": "Villanova University",
  "virginia_tech": "Virginia Institute of Technology (Virginia Tech)",
  "wake_forest_university": "Wake Forest University",
  "washington_and_lee_university": "Washington and Lee University",
  "washington_university_in_st_louis": "Washington University in St. Louis",
  "wellesley_college": "Wellesley College",
  "wesleyan_university": "Wesleyan University",
  "williams_college": "Williams College",
  "worcester_polytechnic_institute": "Worcester Polytechnic Institute (WPI)",
  "yale_university": "Yale University"
};
